import RichText from '../general-components/RichText';

const Prep = ({
    description,
    d,
    onUpdateConditionalField,
}: {
    d: string;
    description: any;
    onUpdateConditionalField: Function;
}) => {
    return (
        <RichText
            description={description}
            onChange={(richText) => onUpdateConditionalField(d, richText)}
        />
    );
};

export default Prep;
